import { render } from "./CerezPolitikasi.vue?vue&type=template&id=241903a4&scoped=true"
import script from "./CerezPolitikasi.vue?vue&type=script&lang=js"
export * from "./CerezPolitikasi.vue?vue&type=script&lang=js"

import "./CerezPolitikasi.vue?vue&type=style&index=0&id=241903a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-241903a4"]])

export default __exports__